import { STRING_CONSTANTS } from '@shared-constants';

export const isEmptyString = (value: string | null | undefined): boolean => {
  return value == null || value.trim() === STRING_CONSTANTS.EMPTY;
};

export const hasValue = (value: string | null | undefined): boolean => {
  return !isEmptyString(value);
};

/**
 * Capitalizes the first letter of every word and lowercases the rest, so
 * names stored in caps ("JULIAN STIVEN") read as "Julian Stiven".
 */
export const toTitleCase = (value: string | null | undefined): string => {
  if (isEmptyString(value)) {
    return STRING_CONSTANTS.EMPTY;
  }

  return (value as string)
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
